import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ProfileBusinessTabsStorage } from '../utils/helpers/profileBusinessTabsStorage';

export enum ProfileBusinessTabsValueEnum {
  packages = 'packages',
  agency = 'agency',
  transfers = 'transfers',
  business = 'business',
  invoices = 'invoices'
}

export const useProfileBusinessTabsState = (isMainAgent?: boolean) => {
  const { t } = useTranslation();

  const tabValuesArray = useMemo(
    () => [
      {
        value: ProfileBusinessTabsValueEnum.packages,
        name: t('pages.profile.packages'),
        stat: 'profile-business-packages'
      },
      {
        value: ProfileBusinessTabsValueEnum.agency,
        name: t('pages.profile.agency'),
        stat: 'profile-business-agency',
        isShown: isMainAgent
      },
      {
        value: ProfileBusinessTabsValueEnum.transfers,
        name: t('pages.profile.transfers'),
        stat: 'profile-business-transfers',
        isShown: isMainAgent
      },
      {
        value: ProfileBusinessTabsValueEnum.business,
        name: t('pages.profile.balance'),
        stat: 'profile-business-balance'
      },
      {
        value: ProfileBusinessTabsValueEnum.invoices,
        name: t('pages.profile.invoices'),
        stat: 'profile-business-invoices'
      }
    ],
    [t, isMainAgent]
  );

  const initialActiveTab =
    ProfileBusinessTabsStorage.getActiveTab() || tabValuesArray[0].value;
  const [currentTabValue, setCurrentTabValue] = useState(initialActiveTab);

  useEffect(() => {
    if (
      (currentTabValue === ProfileBusinessTabsValueEnum.agency ||
        currentTabValue === ProfileBusinessTabsValueEnum.transfers) &&
      isMainAgent === false
    ) {
      setCurrentTabValue(ProfileBusinessTabsValueEnum.packages);
    }
  }, [currentTabValue, isMainAgent]);

  const optionHandleClick = (value: ProfileBusinessTabsValueEnum) => {
    setCurrentTabValue(value);
    ProfileBusinessTabsStorage.setActiveTab(value);
  };

  return {
    currentTabValue,
    optionHandleClick,
    tabValuesArray
  };
};
